/**
 * NewProducts Functional Component
 * @Package - seo
 * @Author - Manila@UPWA-Team
 * @description: NewProducts for SEO pages
 */

import React from 'react'
import { Box, ResponsiveBox } from '@usap/uicomponents'
import { Title } from '../meta'
import NewProductsCard from './NewProductsCard'

export default function NewProducts({
  isDesktop,
  records,
  title,
  getReviews,
  Link,
  isBot,
  formatBrand,
}) {
  const fxWidth = records && records.length * 250
  return (
    <ResponsiveBox
      id="NewProducts"
      width="1248px"
      pad={{ horizontal: 'small', vertical: 'medium' }}
      margin={{ horizontal: 'auto', vertical: 'medium' }}
    >
      {records.length !== 0 && (
        <>
          <Box id="NewProductsHeading">
            <Title
              type="h2"
              style={{
                fontSize: '24px',
              }}
              size={isDesktop ? 'medium' : 'small'}
              label={title}
            />
          </Box>

          <ResponsiveBox
            fxStyle={{
              other: { minWidth: '300px', overflowY: 'auto' },
            }}
          >
            <ResponsiveBox
              id="NewProductsSection"
              direction="row"
              fxWidth={{
                other: `${fxWidth}px`,
                large: '100%',
              }}
            >
              {records
                && records.map(record => (
                  <NewProductsCard
                    data={record}
                    Link={Link}
                    isBot={isBot}
                    getReviews={getReviews}
                    key={record.id}
                    index={record.id}
                    formatBrand={formatBrand}
                  />
                ))}
            </ResponsiveBox>
          </ResponsiveBox>
        </>
      )}
    </ResponsiveBox>
  )
}
